
const PONGFOX_FIX_URL = "https://app.pongfox.com";

const PONGFOX_FIX_URL_DRILL_V1 = "https://app.pongfox.com/drill/v1";
//const PONGFOX_FIX_URL_DRILL_V1 = "http://192.168.0.224:3001/drill/v1";

const PONGFOX_FIX_URL_DRILL_SEMIRANDOM = "https://app.pongfox.com/drill/semirandom";

//const PONGFOX_FIX_URL_DRILL_SEMIRANDOM = "http://192.168.0.224:3001/drill/semirandom";

//const BACKEND_API_URL = "http://127.0.0.1:8000"; // This use for localhost

const BACKEND_API_URL = "https://app.pongfox.com/ai";

const BACKEND_API_URL_MYDRILLS_DEVICE = `${BACKEND_API_URL}/mydrills/device`;

const BACKEND_API_URL_CREATE_DRILL = `${BACKEND_API_URL}/create_drill`;

const BACKEND_API_URL_FOR_GET_SESSION_BY_ID = `${BACKEND_API_URL}/session/id`;

export { 
     PONGFOX_FIX_URL,
     PONGFOX_FIX_URL_DRILL_V1, 
     PONGFOX_FIX_URL_DRILL_SEMIRANDOM, 
     BACKEND_API_URL,
     BACKEND_API_URL_MYDRILLS_DEVICE,
     BACKEND_API_URL_CREATE_DRILL,
     BACKEND_API_URL_FOR_GET_SESSION_BY_ID
    };
